// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2mJSA","title":"Header_title__XlLDx","left":"Header_left__2Hayv","clinicName":"Header_clinicName__24zFP"};